import React from "react";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>Rendszer karbantartás</h1>
		<h2>Tisztelt Kollégák, Kedves Felhasználók!</h2>
		<p>
			2025.03.16 (vasárnap) 06:00 - 12:00 között a rendszer adatbázis
			verzió frissítés miatt nem lesz elérhető, ebben az időintervallumban
			nem tudják majd használni. Amennyiben a karbantartás ideje alatt
			szükségük lenne valamely páciensük adataira, akkor kérjük írjanak
			e-mail üzenetet az info@fyrms.com címre.
		</p>
		<p>Megértésüket és türelmüket előre is köszönjük!</p>
	</section>
);
